import { format } from 'date-fns';
import { uk } from 'date-fns/locale';

export const DEFAULT_DATE_FORMAT = 'dd.MM.yyyy';
export const LONG_DATE_FORMAT = 'dd MMMM yyyy';
export const DEFAULT_TIME_FORMAT = 'HH:mm:ss';

export const renderDate = (utc, dateFormat = DEFAULT_DATE_FORMAT) => {
  const d = new Date(utc);
  return d ? format(d, dateFormat, { locale: uk }) : '';
};

export const renderDateLong = (utc) => {
  const d = new Date(utc);
  return d ? format(d, LONG_DATE_FORMAT, { locale: uk }) : '';
};
